import Vue from 'vue'
import VueMoment from 'vue-moment'

import moment from 'moment-timezone'
import './components'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@/styles/index.css'

import router from '@/router'
import routerInterceptor from '@/router/routerInterceptor'
import store from '@/store'

require('moment/locale/ro')
moment.locale('ro')
sync(store, router)
Vue.use(Vuetify)
Vue.use(VueMoment, {
  moment
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#4d85ff',
          custom: '#ff0000',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#b71c1c',
          white: '#ffffff',
          gry: '#3a4652'
        }
      }
    },
    icons: {
      iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    }
  }),
  store,
  router,
  routerInterceptor,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js